/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../models/Models/v4/Application/application-response-base-response';
import { ApplicationWithdrawRequestBaseResponse as ModelsV4ApplicationApplicationWithdrawRequestBaseResponse } from '../models/Models/v4/Application/application-withdraw-request-base-response';
import { LoanFileRequestBaseResponse as ModelsV4ApplicationLoanFileRequestBaseResponse } from '../models/Models/v4/Application/loan-file-request-base-response';
import { ApplicationUpdateVehicleResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse } from '../models/Models/v4/Application/Public/application-update-vehicle-response-base-response';
import { v4ApplicationPersonalloanApplicationIdFilePost$Json } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-json';
import { V4ApplicationPersonalloanApplicationIdFilePost$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-json';
import { v4ApplicationPersonalloanApplicationIdFilePost$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-plain';
import { V4ApplicationPersonalloanApplicationIdFilePost$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-plain';
import { v4ApplicationPersonalloanApplicationIdFilePost$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-xml';
import { V4ApplicationPersonalloanApplicationIdFilePost$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-file-post-xml';
import { v4ApplicationPersonalloanApplicationIdPut$Json } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-put-json';
import { V4ApplicationPersonalloanApplicationIdPut$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-put-json';
import { v4ApplicationPersonalloanApplicationIdPut$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-put-plain';
import { V4ApplicationPersonalloanApplicationIdPut$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-put-plain';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-json';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-json';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-plain';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-plain';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-xml';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-json-xml';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-json';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-json';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-plain';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-plain';
import { v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-xml';
import { V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-application-id-withdraw-post-xml-xml';
import { v4ApplicationPersonalloanBrokerPost$Json$Json } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-json';
import { V4ApplicationPersonalloanBrokerPost$Json$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-json';
import { v4ApplicationPersonalloanBrokerPost$Json$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-plain';
import { V4ApplicationPersonalloanBrokerPost$Json$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-plain';
import { v4ApplicationPersonalloanBrokerPost$Json$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-xml';
import { V4ApplicationPersonalloanBrokerPost$Json$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-json-xml';
import { v4ApplicationPersonalloanBrokerPost$Xml$Json } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-json';
import { V4ApplicationPersonalloanBrokerPost$Xml$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-json';
import { v4ApplicationPersonalloanBrokerPost$Xml$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-plain';
import { V4ApplicationPersonalloanBrokerPost$Xml$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-plain';
import { v4ApplicationPersonalloanBrokerPost$Xml$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-xml';
import { V4ApplicationPersonalloanBrokerPost$Xml$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-broker-post-xml-xml';
import { v4ApplicationPersonalloanPost$Json$Json } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-json';
import { V4ApplicationPersonalloanPost$Json$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-json';
import { v4ApplicationPersonalloanPost$Json$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-plain';
import { V4ApplicationPersonalloanPost$Json$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-plain';
import { v4ApplicationPersonalloanPost$Json$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-xml';
import { V4ApplicationPersonalloanPost$Json$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-json-xml';
import { v4ApplicationPersonalloanPost$Xml$Json } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-json';
import { V4ApplicationPersonalloanPost$Xml$Json$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-json';
import { v4ApplicationPersonalloanPost$Xml$Plain } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-plain';
import { V4ApplicationPersonalloanPost$Xml$Plain$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-plain';
import { v4ApplicationPersonalloanPost$Xml$Xml } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-xml';
import { V4ApplicationPersonalloanPost$Xml$Xml$Params } from '../fn/personal-loan-application/v-4-application-personalloan-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class PersonalLoanApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ApplicationPersonalloanPost()` */
  static readonly V4ApplicationPersonalloanPostPath = '/v4/application/personalloan';

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Plain$Response(params?: V4ApplicationPersonalloanPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Plain(params?: V4ApplicationPersonalloanPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Json$Response(params?: V4ApplicationPersonalloanPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Json(params?: V4ApplicationPersonalloanPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Xml$Response(params?: V4ApplicationPersonalloanPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanPost$Json$Xml(params?: V4ApplicationPersonalloanPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Plain$Response(params?: V4ApplicationPersonalloanPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Plain(params?: V4ApplicationPersonalloanPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Json$Response(params?: V4ApplicationPersonalloanPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Json(params?: V4ApplicationPersonalloanPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Xml$Response(params?: V4ApplicationPersonalloanPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanPost$Xml$Xml(params?: V4ApplicationPersonalloanPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationPersonalloanBrokerPost()` */
  static readonly V4ApplicationPersonalloanBrokerPostPath = '/v4/application/personalloan/broker';

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Plain$Response(params?: V4ApplicationPersonalloanBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Plain(params?: V4ApplicationPersonalloanBrokerPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Json$Response(params?: V4ApplicationPersonalloanBrokerPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Json(params?: V4ApplicationPersonalloanBrokerPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Xml$Response(params?: V4ApplicationPersonalloanBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanBrokerPost$Json$Xml(params?: V4ApplicationPersonalloanBrokerPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Plain$Response(params?: V4ApplicationPersonalloanBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Plain(params?: V4ApplicationPersonalloanBrokerPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Json$Response(params?: V4ApplicationPersonalloanBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Json(params?: V4ApplicationPersonalloanBrokerPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanBrokerPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Xml$Response(params?: V4ApplicationPersonalloanBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4ApplicationPersonalloanBrokerPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Personal Loan application by a broker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanBrokerPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanBrokerPost$Xml$Xml(params?: V4ApplicationPersonalloanBrokerPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4ApplicationPersonalloanBrokerPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationPersonalloanApplicationIdPut()` */
  static readonly V4ApplicationPersonalloanApplicationIdPutPath = '/v4/application/personalloan/{applicationId}';

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdPut$Plain$Response(params: V4ApplicationPersonalloanApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdPut$Plain(params: V4ApplicationPersonalloanApplicationIdPut$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdPut$Json$Response(params: V4ApplicationPersonalloanApplicationIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdPut$Json(params: V4ApplicationPersonalloanApplicationIdPut$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationPersonalloanApplicationIdFilePost()` */
  static readonly V4ApplicationPersonalloanApplicationIdFilePostPath = '/v4/application/personalloan/{applicationId}/file';

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdFilePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Plain$Response(params: V4ApplicationPersonalloanApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdFilePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdFilePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Plain(params: V4ApplicationPersonalloanApplicationIdFilePost$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdFilePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdFilePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Json$Response(params: V4ApplicationPersonalloanApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdFilePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdFilePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Json(params: V4ApplicationPersonalloanApplicationIdFilePost$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdFilePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdFilePost$Xml()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Xml$Response(params: V4ApplicationPersonalloanApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdFilePost$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a related file for the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdFilePost$Xml$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  v4ApplicationPersonalloanApplicationIdFilePost$Xml(params: V4ApplicationPersonalloanApplicationIdFilePost$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationLoanFileRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdFilePost$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationLoanFileRequestBaseResponse>): ModelsV4ApplicationLoanFileRequestBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4ApplicationPersonalloanApplicationIdWithdrawPost()` */
  static readonly V4ApplicationPersonalloanApplicationIdWithdrawPostPath = '/v4/application/personalloan/{applicationId}/withdraw';

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Response(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>> {
    return v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraw the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml(params: V4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse> {
    return this.v4ApplicationPersonalloanApplicationIdWithdrawPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationWithdrawRequestBaseResponse>): ModelsV4ApplicationApplicationWithdrawRequestBaseResponse => r.body)
    );
  }

}
